module.exports = __webpack_public_path__ + "img/error.5dae5955.png";